"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _flowbiteReact = require("flowbite-react");
var _jsxRuntime = require("react/jsx-runtime");
const CardItems = _ref => {
  let {
    bg,
    obj
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: obj.map((item, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "max-w-sm cardItem",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_flowbiteReact.Card, {
        className: bg === "dark" ? "!bg-primaryDark text-white" : bg === "light" ? "!bg-darkSix" : "!bg-darkSix",
        children: [item.icon, /*#__PURE__*/(0, _jsxRuntime.jsx)("h4", {
          children: item.card_title
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: item.card_content
        })]
      })
    }, index))
  });
};
var _default = CardItems;
exports.default = _default;